import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../../vitals/store/vitals.constants'
import { getPatientVitalsSelector } from '../../vitals/selectors/patientVitals.selector'
import { IPatientVitals } from '../../vitals/store/vitals.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { IItem, IVitalItem } from '../store/timeline.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../store/timeline.constants'
import { getKeyIfPertinentNegativeOrNotValueSelected } from '../../../utilities/pnnv.util'
import { isValidVitalData } from '../../nemsisData/utils/customElements.util'

export function* addPatientVitalItemData() {
  const timeline = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const {
    pta,
    date,
    time,
    systolicBP,
    systolicBPPNNV,
    diastolicBP,
    diastolicBPPNNV,
    heartRate,
    heartRatePNNV,
    respirationRate,
    respirationRatePNNV,
    spo2,
    spo2PNNV,
    temperature,
    temperaturePNNV,
    comments,
    key,
    isEkgImport,
    clientEventId,
    vsAction,
  } = patientVital
  const dateTime = new Date(date || 0)
  const isValidData = isValidVitalData(patientVital)
  const clientCorrelationId = `patient.patientVitals_${key}`
  if (time) {
    if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
    dateTime.setMinutes(+time.split(':')[1])
    dateTime.setHours(+time.split(':')[0])
  }
  const vitalItem: IVitalItem = {
    key: key,
    itemType: 'Vitals',
    grid: true,
    keyValues: [{ key: '', value: '' }],
    labelHeaderFlag: pta ? 'PTA' : '',
    labelHeader: time,
    paragraph: comments,
    rowActionType: TimelineConstants.SET_VITAL_ITEM,
    defaultHref: TabConstants.VITALS_TAB,
    date: dateTime,
    clientCorrelationId: isValidData ? clientCorrelationId : '',
    isEkgImport: isEkgImport,
    ...(clientEventId && { clientEventId: clientEventId.toString() }),
    ...(vsAction && { vsAction: vsAction }),
  }
  vitalItem.subHeader = date
  vitalItem.event = 'Vitals'
  vitalItem.keyValues = [
    {
      key: 'HR',
      value: heartRate || getKeyIfPertinentNegativeOrNotValueSelected(heartRatePNNV) || '',
      columnSize: '1',
    },
    {
      key: 'BP',
      value: `${systolicBP || getKeyIfPertinentNegativeOrNotValueSelected(systolicBPPNNV) || ''}/${
        diastolicBP || getKeyIfPertinentNegativeOrNotValueSelected(diastolicBPPNNV) || ''
      }  `,
      columnSize: '1',
    },
    {
      key: 'RR',
      value: respirationRate || getKeyIfPertinentNegativeOrNotValueSelected(respirationRatePNNV) || '',
      columnSize: '1',
    },
    { key: 'SpO2', value: spo2 || getKeyIfPertinentNegativeOrNotValueSelected(spo2PNNV) || '', columnSize: '1' },
    {
      key: 'Temp',
      value: temperature || getKeyIfPertinentNegativeOrNotValueSelected(temperaturePNNV) || '',
      hideOnMobile: 'true',
      columnSize: '1',
    },
  ]

  const index = items.findIndex((item: IItem) => item.key === key)
  if (index !== -1) {
    items[index] = vitalItem
  } else {
    items.push(vitalItem)
  }
  yield put(setActivityLog(items))
  yield put(saveTimelineItems())
}
export function* addPatientVitalItemDataSaga() {
  yield takeLatest([VitalsConstants.ADD_TO_TIMELINE], addPatientVitalItemData)
}
